import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/admin/PrivateListingAttempts";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/private-listing-attempts/")({
  head: () => routeHead("/admin/private-listing-attempts/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
